<template>
  <div class="confirm-time">
    <div class="first">
      <span class="text-subtitle-1 font-weight-bold pink--text text--darken-1">{{time | format('j')}}</span>
      <small class="text--secondary"> 日 </small>
      <span class="text-subtitle-1 font-weight-bold pink--text text--darken-1">{{time | format('H:i')}}</span>
    </div>
    <div class="second">
      <small>{{time | format('Y年n月')}}</small>
      <small class="week">{{time | format('(x)')}}</small>
    </div>
  </div>
</template>

<style lang="scss">
@import '@/libs/vuetify/styles/variables.scss';

.confirm-time {
  background-color: $light-grey2-color;
  border-radius: 3px;
  padding: .25rem .5rem;

  .first, .second {
    text-align: center;
  }

  .week {
    margin-left: .5em;
  }
}
</style>

<script>
import * as time from '@/libs/time'

export default {
  name: 'ConfirmTime',
  props: {
    time: {
      type: Date,
      required: true
    }
  },
  filters: {
    format (tm, fmt) {
      return time.format(fmt, tm)
    }
  }
}
</script>
